import css from './Eyes.css';
import {throttle} from "../utils";

export class Eyes {
    constructor(parentEl = document.body, eyeCount = 2) {
        this._containerEl = document.createElement('div');
        this._containerEl.className = css.container;
        this._eyeEls = new Array(eyeCount).fill(null)
            .map(this._createEyeEl);

        this._eyeEls.forEach(({eye}) => this._containerEl.appendChild(eye));

        document.addEventListener('mousemove', throttle((e) => requestAnimationFrame(() => {
            this._eyeEls.forEach(({eye, ball}) => {
                const {x, y} = eye.getBoundingClientRect();
                const resX = 100 * (e.pageX - x) / window.innerWidth;
                const resY = 100 * (e.pageY - y) / window.innerHeight;
                ball.style = `transform: translate(${resX}%, ${resY}%)`
            })
        }), 30));

        parentEl.appendChild(this._containerEl);
    }

    hide() {
        this._setEyesClass(true);
    }

    show() {
        this._setEyesClass(false);
    }

    _setEyesClass(isHidden) {
        this._eyeEls.forEach(({eye}) => eye.className = css.eye + (isHidden ? (' ' + css["eye--hidden"]) : ''))
    }

    _createEyeEl() {
        const eye = document.createElement('div');
        eye.className = css.eye;
        const ball = document.createElement('div');
        ball.className = css.ball;

        eye.appendChild(ball);
        return {eye, ball};
    }
}
